import { render, staticRenderFns } from "./CourseCategoryTable.vue?vue&type=template&id=f3a01be4"
import script from "./CourseCategoryTable.vue?vue&type=script&lang=js"
export * from "./CourseCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports